(()=> {
    // Navigation
    const body            = document.body;
    const openMenu        = body.querySelector('.open-menu');
    const menuOverlay     = openMenu.nextElementSibling;
    const elContent       = body.querySelector('.content');

    function scrollControl() {
        if (elContent.classList.contains("menu-open")) {
            var scrollY = document.documentElement.style.getPropertyValue('--scroll-y');

            body.style.position = 'fixed';
            body.style.width = '99%';
            body.style.right = '1%';
            body.style.top = "-".concat(scrollY);
        } else {
            var scrollY = body.style.top;

            body.style.position = '';
            body.style.width = '';
            body.style.right = '';
            body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }

        window.addEventListener('scroll', function () {
            document.documentElement.style.setProperty('--scroll-y', "".concat(window.scrollY, "px"));
        });
    }

    const mobileWidth   = "100vw";
    const desktopWidth  = "50vw";

    function getWidth () {
        return (window.matchMedia('(min-width:1024px)').matches)
            ? desktopWidth
            : mobileWidth
        ;
    }

    function setWidth () {
        menuOverlay.style.width = getWidth()
    }

    setWidth()
    
    window.addEventListener('resize', () => {
        setWidth()
    })

    const loggedIn = document.getElementsByClassName('hdr-logged-in')

    openMenu.addEventListener('click', function (e) {
        if (!loggedIn[0]) return
        
        // e.stopImmediatePropagation();
        openMenu.classList.toggle("active");
        menuOverlay.classList.toggle("open");
        elContent.classList.toggle("menu-open");

        $(menuOverlay).toggle('slide');
        scrollControl();

        const currentOpen = openMenu
        const parentClass = currentOpen.parentElement.getAttribute('class');
        const currentClass = currentOpen.getAttribute('class');
        if (currentClass.includes('active')) {
            HAHAccessibility.trapFocus({
                container: `.${parentClass}`,
                closeElement: '.open-menu.active',
                firstElementToFocus: '.ADA_firstElement',
                unbindEvents: true
            });
            currentOpen.setAttribute('aria-busy', 'false');
            currentOpen.setAttribute('aria-label', 'Close Menu');
            currentOpen.removeAttribute('aria-haspopup');
            currentOpen.removeAttribute('aria-expanded');
        } else {
            currentOpen.setAttribute('aria-busy', 'false');
            const parentClass = currentOpen.parentElement.getAttribute('class');
            currentOpen.setAttribute('aria-expanded', 'false');
            currentOpen.setAttribute('aria-haspopup', 'dialog');
            if(parentClass === "search") {
              currentOpen.setAttribute('aria-label', 'Search Menu');
            } else if(parentClass === "global-sites") {
              currentOpen.setAttribute('aria-label', 'Languages');
            } else if(parentClass === "hdr-account") {
              currentOpen.removeAttribute('aria-label');
            }
        }
    });
})();